import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { integrationApiService, type IntegrationConfig } from '../services/integrationApi';
import { deriveStorePlatform, type StorePlatformInfo } from '../utils/storePlatform';

export interface UseStorePlatformResult extends StorePlatformInfo {
  integrations: IntegrationConfig[];
  loading: boolean;
}

/** The store's connected platform(s). Shares the ['integrations'] cache with the other store pages. */
export function useStorePlatform(enabled = true): UseStorePlatformResult {
  const query = useQuery<IntegrationConfig[]>({
    queryKey: ['integrations'],
    queryFn: () => integrationApiService.getIntegrations(),
    enabled,
  });
  const integrations = useMemo(() => query.data || [], [query.data]);
  const info = useMemo(() => deriveStorePlatform(integrations), [integrations]);
  return { ...info, integrations, loading: enabled && query.isLoading };
}
